import { client } from "../gqlClient";
import {
  GET_COUNTRIES,
  GET_COUNTRY,
  CREATE_COUNTRY,
  UPDATE_COUNTRY,
} from "./schema";
import {
  Country,
  CountryFilter,
  CreateCountryInput,
  UpdateCountryInput,
} from "../../types/graphql";
import {
  convertAdminPgToGraphqlRelayPg,
  convertAdminSortToGraphqlSort,
} from "../utils";

export async function getListCountries(params: {
  pagination?: any;
  sort?: any;
  filter?: CountryFilter;
}): Promise<{
  data: Country[];
  total: number;
}> {
  const data = await client.query(GET_COUNTRIES, {
    filter: params.filter || null,
    pagination: convertAdminPgToGraphqlRelayPg(params.pagination),
    sort: convertAdminSortToGraphqlSort(params.sort),
  });

  if (!data?.countries?.edges) {
    return { data: [], total: 0 };
  }

  return {
    data: data.countries.edges.map((edge: any) => edge.node),
    total: data.countries.totalCount || 0,
  };
}

export async function getOneCountry(params: {
  id: string;
}): Promise<{ data: Country }> {
  const { id } = params;
  const data = await client.query(GET_COUNTRY, { id }, "admin.countryById");

  return {
    data,
  };
}

export async function createCountry(params: {
  data: CreateCountryInput;
}): Promise<{ data: Country }> {
  const { data } = params;
  const country = await client.mutate(
    CREATE_COUNTRY,
    {
      input: data,
    },
    "adminCountryCreate"
  );

  return {
    data: country,
  };
}

export async function updateCountry(params: {
  id: string;
  data: UpdateCountryInput;
}): Promise<{ data: Country }> {
  const { id, data } = params;
  const country = await client.mutate(
    UPDATE_COUNTRY,
    {
      id,
      input: data,
    },
    "adminCountryUpdate"
  );

  return {
    data: country,
  };
}
